import React, { useState, useEffect } from 'react'
import { Container, Col, Modal, Button, Form, Row } from 'react-bootstrap';
import { CustomButton } from '../../../../../shared/customButton';
import styles from "./review.module.scss"
import { CustomAlertBox } from '../../../../../shared/customAlertBox';
import {shareExternalMeetingDetails ,endMeetingForAll} from '../../../../../../services/util/interviews';

const Review = (props) => {

    const [isSubmissionPending, setIsSubmissionPending] = useState(false)
    
    const submitDetails = async () => {
        setIsSubmissionPending(true)
        let results = await shareExternalMeetingDetails(props.values.session_id, props.values.externalMeetingURL,props.values.description);
        if (results.success === true) {
            setIsSubmissionPending(false);
            await endMeetingForAll(props.values.session_id);
            window.location.reload();
            props.handleClose();
        }
        else {
            setIsSubmissionPending(false);
            window.location.reload();
        }
    }

    return (
        <div>

            <Row className='mt-3 '>
                <div>
                    <p className={styles.cardTopics}>Meeting URL : &nbsp; <span className={styles.cardValues}>{props.values.externalMeetingURL}</span></p>
                </div>
            </Row>
            <Row className='mb-4'>
                <div>
                    <p className={styles.cardTopics}>Description : &nbsp; <span className={styles.cardValues}>{props.values.description ? props.values.description :'Not Available' }</span></p>
                </div>
            </Row>
            
            <Row>
                <Col>
                    <CustomAlertBox 
                        alertType='warningAlert'
                        alertBodyText={`Please double check the details before submitting. You cannot edit it later.`}
                    />
                </Col>
            </Row>
            <Row className="mt-3 mb-5">
                <Col>
                    {<CustomButton
                        buttonType="button"
                        label="Back"
                        type="defaultBtn"
                        handleClick={() => props.previousPage(1)}

                    />}
                </Col>

                <Col>
                    <CustomButton
                        buttonType="submit"
                        label="Send"
                        type="primaryBtn"
                        backicon={isSubmissionPending ? <i className="fas fa-circle-notch fa-spin" aria-hidden="true"></i> : null}
                        disabled={isSubmissionPending ? true : false}
                        handleClick={() => submitDetails()}
                    />
                </Col>
            </Row>
        </div>
    )
}

export default Review